import { FinanceStatisticsDto } from "@modules/finances/gateway/financeStatisticsDto"
import { PayoutTransferStatus } from "@modules/finances/types/financesType"

export class FinanceStatisticsEntity {
  totalTransactionsValue: number
  totalTransactionsCurrency: string
  activeMembersNumber: number
  pendingBalanceForTransfer: number | null
  availableBalanceForTransfer: number | null
  transferArrivalDate: string | null
  transferStatus: PayoutTransferStatus | null
  transferAmount: number | null

  private constructor(data: FinanceStatisticsEntity) {
    this.totalTransactionsValue = data.totalTransactionsValue
    this.totalTransactionsCurrency = data.totalTransactionsCurrency
    this.activeMembersNumber = data.activeMembersNumber
    this.pendingBalanceForTransfer = data.pendingBalanceForTransfer
    this.availableBalanceForTransfer = data.availableBalanceForTransfer
    this.transferArrivalDate = data.transferArrivalDate
    this.transferStatus = data.transferStatus
    this.transferAmount = data.transferAmount
  }

  static fromDto(dto: FinanceStatisticsDto) {
    return new FinanceStatisticsEntity({
      totalTransactionsValue: dto.totalTransactionsValue,
      totalTransactionsCurrency: dto.totalTransactionsCurrency,
      activeMembersNumber: dto.activeMembersNumber,
      pendingBalanceForTransfer: dto.pendingBalanceForTransfer,
      availableBalanceForTransfer: dto.availableBalanceForTransfer,
      transferArrivalDate: dto.transferArrivalDate,
      transferStatus: dto.transferStatus,
      transferAmount: dto.transferAmount,
    })
  }
}
